/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState } from 'react'

import { View } from '@components/atoms'
import { SeasonListItem } from '@components/molecules'
import { SeasonType, SeasonModificationType } from '@schemas'
import { SeasonDeleteConfirmationModal } from '@components/molecules'
import { SeasonModificationModal } from '@components/molecules'
import { useAppDispatch } from '@redux/index'
import { seasonActions } from '@redux/store/index'

interface SeasonListProps {
	seasons: SeasonType[]
	selectedSeasonId: string
	onSeasonClick: (season: SeasonType) => void
}

export const SeasonList = (props: SeasonListProps) => {
	const { seasons, selectedSeasonId, onSeasonClick } = props

	const dispatch = useAppDispatch()
	const [deleteModalOpen, setDeleteModalOpen] = useState(false)
	const [modifyModalOpen, setModifyModalOpen] = useState(false)
	const [selectedSeason, setSelectedSeason] = useState<SeasonType | null>(null)

	const handleDeleteClick = (season: SeasonType) => {
		setSelectedSeason(season)
		setDeleteModalOpen(true)
	}

	const handleModifyClick = (season: SeasonType) => {
		setSelectedSeason(season)
		setModifyModalOpen(true)
	}

	const handleDelete = () => {
		if (selectedSeason) {
			dispatch(seasonActions.DELETE_SEASON(selectedSeason.id))
			setDeleteModalOpen(false)
			setSelectedSeason(null)
		}
	}

	const handleModify = (seasonId: string, updatedSeason: SeasonModificationType) => {
		if (selectedSeason) {
			dispatch(
				seasonActions.UPDATE_SEASON({ id: selectedSeason.id, season: updatedSeason }),
			)
			setModifyModalOpen(false)
			setSelectedSeason(null)
		}
	}

	return (
		<View css={style}>
			<View className="seasonListView">
				{seasons && seasons.length > 0 ? (
					seasons.map(season => {
						const isSelected = season.id === selectedSeasonId
						return (
							<SeasonListItem
								key={season.id}
								{...season}
								isSelected={isSelected}
								onClick={() => onSeasonClick(season)}
								onDelete={() => handleDeleteClick(season)}
								onEdit={() => handleModifyClick(season)}
							/>
						)
					})
				) : (
					<p>No seasons available.</p>
				)}
			</View>

			<SeasonDeleteConfirmationModal
				open={deleteModalOpen}
				onClose={() => setDeleteModalOpen(false)}
				onDelete={handleDelete}
				seasonTitle={selectedSeason ? selectedSeason.title : ''}
			/>
			<SeasonModificationModal
				open={modifyModalOpen}
				onClose={() => setModifyModalOpen(false)}
				onSubmit={handleModify}
				initialValues={selectedSeason || undefined}
			/>
		</View>
	)
}

const style = css({
	overflow: 'auto',
	height: '100%',
	width: '100%',
	padding: '0.5rem 1rem',

	seasonListView: {},
})
